<template>
  <a-modal title="匹配框架合同" v-model="modalShow" width="80%" @cancel="close" destroyOnClose>
    <a-form-model class="common-form-inline" :rules="ruleForm" ref="ruleForm" :model="pageData" :label-col="{ span: 7 }"
      :wrapper-col="{ span: 13 }">
      <div class="common-title">框架合同信息</div>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="框架合同编号" prop="invoiceMainContractId">
            <a-select show-search v-model="pageData.invoiceMainContractId" placeholder="请输入关键字"
              :default-active-first-option="false" :show-arrow="false" :filter-option="false" :not-found-content="null"
              @search="getContractList" @change="invoiceChange">
              <a-select-option v-for="item in invoiceList" :key="item.id" :value="item.id">{{ item.contractNo }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>

      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="卖方名称">
            {{sellrName}}
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="框架合同附件">
            <fileUpload ref="fileUpload" :showList="invoiceFile" :disabled="true" name="file" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <div class="common-title">合同列表</div>
    <div class="table-common common">
      <a-table size="middle" :columns="columns" :row-key="(record) => record.id" :data-source="tableData"
        :pagination="false" bordered :locale="{ emptyText: '暂无数据' }">
        <template slot="signDate" slot-scope="text">
          {{text | dateFormat("YYYY-mm-dd")}}
        </template>
        <template slot="contractAmt" slot-scope="text">
          {{text | splitK }}
        </template>
      </a-table>
    </div>
    <template slot="footer">
      <a-button class="btn-blue-line" @click="close()">取消</a-button>
      <button-load @clickHandle="save" type="primary" lable="保存" />
    </template>
  </a-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import { contractList } from '@/api/contract.js'
import { matchMainContract } from '@/api/orderContract.js'

export default {
  components: {},
  name: 'invoice-info-dialog',
  data() {
    return {
      modalShow: false,
      confirmLoading: false,
      tableData: [],
      pageData: {
        invoiceMainContractId: undefined,
        contractIds:undefined,
      },
      sellrName: undefined,
      invoiceList: [],
      invoiceFile: [],
      ruleForm: {
        invoiceMainContractId: [
          { required: true, message: '框架合同不能为空', trigger: 'blur' },
        ]
      },
      columns: [
        {
          title: '卖方名称',
          dataIndex: 'sellrName',
          ellipsis: true,
        },
        {
          title: '合同编号',
          dataIndex: 'contractNo',
          scopedSlots: { customRender: 'contractNo' },
        },
        {
          title: '合同金额(元)',
          dataIndex: 'contractAmt',
          scopedSlots: { customRender: 'contractAmt' },
        },
        {
          title: '签署日期',
          dataIndex: 'signDate',
          scopedSlots: { customRender: 'signDate' },
        },
        {
          title: '合同名称',
          dataIndex: 'contractName',
          scopedSlots: { customRender: 'contractName' },
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      userObj: 'home/getUserObj',
    }),

  },
  created() {
  },
  methods: {
    open(list,ids) {
      this.pageData.contractIds = ids.join(',')
      this.tableData = list
      this.invoiceList = []
      this.modalShow = true

    },
    getContractList(value) {
      if (value) {
        let params = {
          pageNum: 1,
          pageSize: 100,
          orderBy: 'createTime asc',
          contractNo: value || '',
          buryOrgCode: this.$store.getters['home/getUserObj'].orgCode,
          sellrOrgCode: this.tableData[0].sellrOrgCode,
        }
        contractList(params).then((res) => {
          this.invoiceList = res.data.grid.list
        })
      }

    },
    invoiceChange() {
      this.invoiceFile = []
      let item = this.invoiceList.find((item) => item.id == this.pageData.invoiceMainContractId)
      this.sellrName = item.sellrName
      this.invoiceFile = [item.fileMap]
    },
    close() {
      this.modalShow = false
      this.invoiceFile = []
      this.$refs.ruleForm.resetFields()
    },
    save(btn) {
      this.confirmLoading = true
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          matchMainContract(this.pageData)
            .then((res) => {
              btn && btn.closeLoad()
              this.confirmLoading = false
              this.$message.success('匹配成功')
              this.close()
              this.$emit('success')
            })
            .catch(() => {
              this.confirmLoading = false
              btn && btn.closeLoad()
            })
        } else {
          this.confirmLoading = false
          btn && btn.closeLoad()
          return false
        }
      })
    },
  },
}
</script>
<style scoped lang="less">
.img-tip {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/pages/bill-manage/orderContract/matchPage.vue